import { cssVars } from '@/styles/Themes/cssVars';
import Palette from '@/styles/Themes/Palette';
import Screen from '@/styles/Themes/Screen';
import Text from '@/styles/Themes/Text';
import styled from 'styled-components';
import { radius } from '@/styles/Themes/Metrics';
import { borders } from '@/styles/Themes/Metrics';

export const Container = styled.div`
    ${Screen.desktop} {
        padding: 0;
        width: 1064px;
        margin: auto;
    }
`;

export const Title = styled.h4`
    ${Text.Full.large.semibold};
    color: ${cssVars.fg_gray1_white};
    margin: 24px 0 0;

    ${Screen.ipad} {
        margin: 34px 0 0;
        ${Text.Ipad.heading4};
    }
    ${Screen.desktop} {
        ${Text.Desktop.heading4};
    }
`;

export const SubTitle = styled.h3`
    display: flex;
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Mobile.medium.medium};
    margin: 3px 0 35px;

    ${Screen.ipad} {
        ${Text.Ipad.large.medium};
    }
    ${Screen.desktop} {
        ${Text.Desktop.large.medium};
    }
`;

export const VoucherNumber = styled.div`
    color: ${Palette.green.normal};
`;

export const VoucherInfoWrapper = styled.div`
    box-shadow: ${cssVars.shadow_container};
    border-radius: ${radius.small};
    background: ${cssVars.bg_white_dark3};
    position: relative;
    padding: 25px 12px 21px;
    margin-bottom: 47px;

    ${Screen.ipad} {
        padding: 32px 40px 40px;
    }
    ${Screen.desktop} {
        width: 1064px;
        margin: 0 auto 60px;
        padding: 79px 69px 41px;
    }
`;

export const InfoContainer = styled.div`
    margin: 0 17px 15px;
    padding: 0 0 15px;
    border-bottom: ${borders.small} ${cssVars.fg_white_dark};

    ${Screen.ipad} {
        display: flex;
        margin: 0 0 18px;
        padding: 0 0 18px;
    }
    ${Screen.desktop} {
        margin: 0 0 25px;
        padding: 0 0 25px;
    }
`;

export const ContactInfoContainer = styled.div`
    margin-bottom: 15px;
    padding: 0 17px 9px;

    ${Screen.ipad} {
        display: flex;
        margin-bottom: 20px;
        padding: 0 0 20px;
    }
    ${Screen.desktop} {
        margin-bottom: 25px;
        padding: 0 0 25px;
    }
`;

export const BarcodesContainer = styled.div`
    background-color: ${cssVars.bg_ash_normal};
    border-radius: ${radius.small};
    padding: 23px 20px 7px;

    ${Screen.ipad} {
        padding: 35px 40px 16px;
    }

    ${Screen.desktop} {
        padding: 46px 30px 10px;
    }
`;

export const BarcodeImg = styled.img`
    width: 100%;
    margin-bottom: 20px;

    ${Screen.ipad} {
        margin-bottom: 25px;
    }

    ${Screen.desktop} {
        width: 100%;
        padding: 0 15px 12px;
    }
`;

export const VoucherNameInfo = styled.div`
    ${Text.Mobile.medium.medium};
    color: ${cssVars.fg_gray1_white};

    ${Screen.ipad} {
        ${Text.Ipad.medium.medium};
        width: 35%;
    }
    ${Screen.desktop} {
        ${Text.Desktop.medium.medium};
        width: 324px;
    }
`;

export const VoucherInfo = styled.div`
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Full.medium.regular};

    ${Screen.ipad} {
        width: 65%;
    }

    a {
        color: ${cssVars.fg_green_greenLight};
        text-decoration: underline;
        font-weight: 500;
    }

    div {
        white-space: pre-wrap;
        ${Text.Full.medium.regular};
    }
    ul {
        padding-left: 10px;
        margin: 0;
    }

    li::marker {
        content: '- ';
    }
`;

export const BottomWrapper = styled.div`
    margin: 25px 0 45px;

    ${Screen.ipad} {
        margin: 60px 0;
    }
`;

export const ContactInfo = styled.div`
    ${Text.Full.large.semibold};
    color: ${cssVars.fg_gray1_white};
    margin-top: 25px;

    ${Screen.ipad} {
        ${Text.Ipad.heading4};
    }
    ${Screen.desktop} {
        ${Text.Desktop.heading5};
    }
`;

export const ConctactNumber = styled.div`
    ${Text.Full.large.medium};
    color: ${cssVars.fg_gray2_gray3};
    margin-bottom: 25px;

    ${Screen.ipad} {
        margin: 1px 0 19px;
    }
    ${Screen.desktop} {
        margin: 2px 0 22px;
    }
`;

export const BarcodesWrapper = styled.div`
    ${Screen.desktop} {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
`;

export const TicketType = styled.div`
    padding-bottom: 15px;
    ${Text.Full.caption.medium};
    color: ${Palette.green.normal};

    ${Screen.desktop} {
        padding: 0 15px 26px;
    }
`;
